/** Only allow in-app paths like "/lists/abc" as post-auth redirect targets. */
export function safeNext(next: string | null | undefined, fallback = '/'): string {
  if (!next) return fallback;
  if (!next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\')) return fallback;
  if (next.startsWith('/login') || next.startsWith('/signup')) return fallback;
  return next;
}

export function loginPath(next?: string) {
  const n = safeNext(next, '');
  return n && n !== '/' ? `/login?next=${encodeURIComponent(n)}` : '/login';
}

export function inviteUrl(token: string) {
  return `${window.location.origin}${window.location.pathname}#/join/${token}`;
}

export function displayName(u: { name: string | null; email: string }) {
  return u.name?.trim() || u.email;
}

export function initials(u: { name: string | null; email: string }) {
  const src = displayName(u);
  const parts = src.split(/[\s@._-]+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '?') + (parts[1]?.[0] ?? '')).toUpperCase();
}
